import api from '../../../api';
import * as getDisableChat from '../../../modules/trader-chat/actions/get-disable-chat';

export function request(dispatch) {
    api.get('/chats/chat-disable').then(
        (result) => dispatch(getDisableChat.finish(result)),
        (errors) => dispatch(getDisableChat.error(errors))
    );
}

